import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-14 px-6 bg-white/50" data-id="element-112">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-4" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy" data-id="element-115">
            Quién es para ti{' '}
            <span className="text-terracotta text-2xl block mt-2 font-sans font-normal" data-id="element-116">
              (y por qué te está doliendo tanto)
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-navy/80 leading-relaxed" data-id="element-117">
          <p data-id="element-118">
            Si hoy estás cuidando a tus padres (o a uno de ellos) y sientes que
            la vida se te hizo más pequeña…{' '}
            <span className="font-semibold text-navy" data-id="element-119">no es imaginación.</span>
          </p>

          <ul className="space-y-3 pl-6 border-l-2 border-terracotta/30 my-4" data-id="element-120">
            <li className="pl-4" data-id="element-121">Tu agenda ya no te pertenece.</li>
            <li className="pl-4" data-id="element-122">Tu mente nunca se apaga.</li>
            <li className="pl-4" data-id="element-123">
              Tu cuerpo está presente, pero tú por dentro estás en "modo
              alerta".
            </li>
          </ul>

          <p data-id="element-124">
            Y aunque nadie lo diga, tú lo sabes: en muchas familias, el cuidado
            no se reparte.{' '}
            <span className="italic font-serif text-xl" data-id="element-125">Se asigna.</span>
          </p>

          <p data-id="element-126">
            Siempre cae en la misma persona.
            <br data-id="element-127" />
            La que resuelve.
            <br data-id="element-128" />
            La que no falla.
            <br data-id="element-129" />
            La que "puede".
          </p>

          <div className="bg-cream border border-navy/10 p-6 rounded-xl mt-6 shadow-sm" data-id="element-130">
            <p className="text-xl font-serif text-navy italic text-center" data-id="element-131">
              "A esa persona muchas veces se le llama, sin decirlo,{' '}
              <span className="text-terracotta font-bold not-italic" data-id="element-132">
                el hijo bastón
              </span>
              : el soporte emocional y práctico cuando el sistema familiar se
              inclina."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}